import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export enum MenuType {
    Report = 'REPORT',
    ExternalLink = 'EXTERNAL_LINK',
}

interface MenuItem {
    type: MenuType;
    name: string;
    url: string;
    text: string;
    items?: MenuItem[];
}

export default autoGeneratedReducer<MenuItem[]>([]);
